var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{class:`modal-container ${_vm.customClass}`},[_vm._t("modal-header"),_vm._t("modal-body"),_vm._t("modal-footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }